import { createStackNavigator } from '@react-navigation/stack'
import React, { FC, useMemo } from 'react'

import { WebNavBar } from './components/WebNavBar'
import { webScreenStyle } from './constants'

import { useDeviceInfo, useDimensions, useNavigationState } from '~hooks'
import { HistoryScreen, OffersListScreen, UserProfileScreen } from '~screens'
import { Routes } from '~types/routesNames'
import { navigationRef } from '~utils'

const { Navigator: NavigatorWeb, Screen: ScreenWeb } = createStackNavigator<WebTabParamList>()
// TODO: fix any type
const screens: {
  name: keyof WebTabParamList
  component: (_?: any) => JSX.Element
}[] = [
  { name: Routes.OffersList, component: OffersListScreen },
  { name: Routes.UserProfile, component: UserProfileScreen },
  { name: Routes.History, component: HistoryScreen },
]

export const WebNavigator: FC = () => {
  const { deviceSpecificWidth, shouldApplyWideScreenStyles } = useDeviceInfo()
  const {
    window: { width: windowWidth },
  } = useDimensions()

  // this is needed to do because its not working fine when navigating from edit profile screen to edit profile (after saving profile info)
  // useNavigationState is rerendering web navigator component and thanks to that we can get currentRouteName when screen change
  useNavigationState((state) => state.routes)

  const currentRouteName = navigationRef.current?.getCurrentRoute()?.name ?? ''

  const renderScreens = useMemo(() => {
    return screens.map((screen) => (
      <ScreenWeb name={screen.name} component={screen.component} key={screen.name} />
    ))
  }, [])

  return (
    <>
      {shouldApplyWideScreenStyles ? <WebNavBar currentRouteName={currentRouteName} /> : null}
      <NavigatorWeb
        initialRouteName={Routes.OffersList}
        screenOptions={{
          headerShown: false,
          cardStyle: {
            ...webScreenStyle,
            paddingHorizontal: (windowWidth - deviceSpecificWidth) / 2,
          },
        }}
      >
        {renderScreens}
      </NavigatorWeb>
      {!shouldApplyWideScreenStyles ? <WebNavBar currentRouteName={currentRouteName} /> : null}
    </>
  )
}
